import { render, staticRenderFns } from "./MDLAddYear.vue?vue&type=template&id=1c6382d9&"
import script from "./MDLAddYear.vue?vue&type=script&lang=js&"
export * from "./MDLAddYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports